import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installChunkReload } from "./chunkReload";

installChunkReload();

const root = document.getElementById("root");
if (!root) {
  throw new Error("No #root element found in index.html");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
